import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import liveReducer from '../pages/live/LiveSlice';
import sportBonusReducer from '../common/sportBonusSlice'
import translationsReducer from '../hooks/translationsSlice'

export const store = configureStore({
  reducer: {
    liveGames: liveReducer,
    sportBonus: sportBonusReducer,
    translations: translationsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
